export type CountryOption = {
  label: string;
  value: string;
};

export const DEFAULT_COUNTRY_CODE = 'US';

export const COUNTRY_CODES: CountryOption[] = [
  { label: 'United States', value: 'US' },
  { label: 'Canada', value: 'CA' },
  { label: 'Mexico', value: 'MX' },
  { label: 'United Kingdom', value: 'GB' },
  { label: 'Australia', value: 'AU' },
  { label: 'Germany', value: 'DE' },
  { label: 'France', value: 'FR' },
  { label: 'Italy', value: 'IT' },
  { label: 'Spain', value: 'ES' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Switzerland', value: 'CH' },
  { label: 'Austria', value: 'AT' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Japan', value: 'JP' },
  { label: 'China', value: 'CN' },
  { label: 'Hong Kong', value: 'HK' },
  { label: 'Singapore', value: 'SG' },
  { label: 'South Korea', value: 'KR' },
  { label: 'India', value: 'IN' },
  { label: 'Brazil', value: 'BR' },
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Sweden', value: 'SE' },
  { label: 'Norway', value: 'NO' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Finland', value: 'FI' },
  { label: 'Poland', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'United Arab Emirates', value: 'AE' },
  { label: 'Israel', value: 'IL' },
  { label: 'Philippines', value: 'PH' },
  { label: 'Taiwan', value: 'TW' },
  { label: 'Thailand', value: 'TH' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Saudi Arabia', value: 'SA' },
  { label: 'South Africa', value: 'ZA' },
];

export const CANADIAN_PROVINCES: CountryOption[] = [
  { label: 'Alberta', value: 'AB' },
  { label: 'British Columbia', value: 'BC' },
  { label: 'Manitoba', value: 'MB' },
  { label: 'New Brunswick', value: 'NB' },
  { label: 'Newfoundland and Labrador', value: 'NL' },
  { label: 'Nova Scotia', value: 'NS' },
  { label: 'Northwest Territories', value: 'NT' },
  { label: 'Nunavut', value: 'NU' },
  { label: 'Ontario', value: 'ON' },
  { label: 'Prince Edward Island', value: 'PE' },
  { label: 'Quebec', value: 'QC' },
  { label: 'Saskatchewan', value: 'SK' },
  { label: 'Yukon', value: 'YT' },
];

export function isUnitedStates(countryCode?: string | null): boolean {
  return (countryCode ?? DEFAULT_COUNTRY_CODE).toUpperCase() === 'US';
}

export function isCanada(countryCode?: string | null): boolean {
  return (countryCode ?? '').toUpperCase() === 'CA';
}

export function isProvinceRequired(countryCode?: string | null): boolean {
  return isUnitedStates(countryCode) || isCanada(countryCode);
}

export function getCountryLabel(countryCode?: string | null): string {
  const normalized = (countryCode ?? DEFAULT_COUNTRY_CODE).toUpperCase();
  return COUNTRY_CODES.find((country) => country.value === normalized)?.label ?? normalized;
}

export function getPostalCodePattern(countryCode?: string | null): RegExp {
  if (isCanada(countryCode)) {
    return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
  }

  if (isUnitedStates(countryCode)) {
    return /^\d{5}(-\d{4})?$/;
  }

  return /^[A-Za-z0-9 -]{2,12}$/;
}

export function getPostalCodeLabel(countryCode?: string | null): string {
  if (isCanada(countryCode)) {
    return 'Postal Code';
  }

  if (isUnitedStates(countryCode)) {
    return 'ZIP Code';
  }

  return 'Postal Code';
}

export function getProvinceLabel(countryCode?: string | null): string {
  if (isUnitedStates(countryCode)) {
    return 'State';
  }

  if (isCanada(countryCode)) {
    return 'Province';
  }

  return 'State / Province';
}
